module.exports = __webpack_public_path__ + "img/67.cdc05535.jpg";